import { CForm, CFormInput, CFormTextarea, } from "@coreui/react";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { t } from 'i18next';
import { useNavigate } from "react-router-dom";
import { ACCOMODATION_IMAGE_TYPE } from "@webkit/enums/accomodation-image-type.enum";
import AccomodationService from "@services/accomodation.service";
import Cookies from 'js-cookie'
import { COOKIE_ENUM } from '@webkit/enums/cookie.enum'
import { BaseAccomodation } from "@models/base-accomodation.model";
import { useSpinner } from "@webkit/components/typescript/SpinnerContext";
import { getToastStore } from "@utils/ToastStore";
import { Contact } from "@models/contact.model";
import { Location } from "@models/location.model";
import { errorToast, successToast } from "@webkit/functions/utils";
import { SaveAccomodation } from "@models/save-accomodation.model";

const contact = {
  whatsapp: '',
  phone: '',
  mobile: '',
  email: '',
  website: '',
  airbnb: '',
  booking: '',
  facebook: '',
  instagram: '',
  youtube: '',
  tiktok: ''
}
interface Row {
  chiave: string;
  value: string;
}

export default function CreateAccomodationPage() {
  const ctxToast = getToastStore();
  const [title, setTitle] = useState('');
  const [details, setDetails] = useState('');
  const [fullAddress, setFullAddress] = useState('');
  const [city, setCity] = useState('');
  const [country, setCountry] = useState('');
  const [selectedLogo, setSelectedLogo] = useState<File | null>(null);
  const [logoPreview, setLogoPreview] = useState<string | null>(null);
  const [longitude, setLongitude] = useState<number>(0);
  const [latitude, setLatitude] = useState<number>(0);

  const [contacts, setContacts] = useState(contact);

  const [selectedCoverImageDesktop, setSelectedCoverImageDesktop] = useState<File | null>(null);
  const [coverDesktopPreview, setCoverDesktopPreview] = useState<string | null>(null);

  const [selectedCoverImageMobile, setSelectedCoverImageMobile] = useState<File | null>(null);
  const [coverMobilePreview, setCoverMobilePreview] = useState<string | null>(null);
  //gestione righe contatti dinamiche
  const [rows, setRows] = useState<[string, string][]>([]);

  const handleAddRow = () => {
    if (rows.length >= 10) return;
    setRows([...rows, ["", ""]]);
  };

  const handleDynamicInputChange = (
        e: React.ChangeEvent<HTMLInputElement>,
        index: number,
        field: "key" | "value"
    ) => {
        const newRows = [...rows];

        if (field === "key") {
            newRows[index] = [e.target.value, newRows[index][1]];
        } else {
            newRows[index] = [newRows[index][0], e.target.value];
        }

        setRows(newRows);
    };

  const navigate = useNavigate();

  const isDisabled = (
    !title.trim() || !fullAddress.trim() ||
    !selectedCoverImageDesktop || !selectedCoverImageMobile ||
    !contacts.whatsapp.trim() ||
    !contacts.mobile.trim() ||
    !contacts.email.trim()
    // !description.trim() ||
  );

  const isDisabledAddress = (
    !fullAddress.trim() ||
    !city.trim() ||
    !country.trim()
  );

  const { showSpinner, hideSpinner } = useSpinner();

  // Cleanup degli object URLs quando il componente viene smontato
  useEffect(() => {
    return () => {

      if (logoPreview) URL.revokeObjectURL(logoPreview);
      if (coverDesktopPreview) URL.revokeObjectURL(coverDesktopPreview);
      if (coverMobilePreview) URL.revokeObjectURL(coverMobilePreview);
    };
  }, []);

  const handleFileChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    type: ACCOMODATION_IMAGE_TYPE
  ) => {
    if (!e.target.files || e.target.files.length === 0) return;
    const maxSize = 5 * 1024 * 1024;
    const file = e.target.files[0];

    if (file.type !== "image/jpeg" && file.type !== "image/png") {
      errorToast(ctxToast, t("error.invalid_image_format"))
      e.target.value = "";
      return;
    }
    if (file.size > maxSize) {
      errorToast(ctxToast, t("error.too_large"))
      e.target.value = "";
      return;
    }

    switch (type) {
      case ACCOMODATION_IMAGE_TYPE.IMAGE_LOGO:
        setSelectedLogo(file);
        setLogoPreview(URL.createObjectURL(file));
        break;
      case ACCOMODATION_IMAGE_TYPE.IMAGE_COVER_DESKTOP:
        setSelectedCoverImageDesktop(file);
        setCoverDesktopPreview(URL.createObjectURL(file));
        break;
      case ACCOMODATION_IMAGE_TYPE.IMAGE_COVER_MOBILE:
        setSelectedCoverImageMobile(file);
        setCoverMobilePreview(URL.createObjectURL(file));
        break;
      default:
        break;
    }
  };

  const handleFullAddressSubmit = async () => {
    showSpinner();
    try {
      const params = {
        street: fullAddress,
        city: city,
        country: country,
        polygon_geojson: 1,
        format: "jsonv2"
      };
      const response = await AccomodationService.getLongitudeAndLatitude(params);

      if (response.length === 0) {
        errorToast(ctxToast, t("error.not_found_address"))
        return
      }

      const first = response[0];

      if (!!first.lat && !!first.lon) {
        setLatitude(parseFloat(first.lat));
        setLongitude(parseFloat(first.lon));
        successToast(ctxToast, t("success.found_lat_lon"));
      } else {
        errorToast(ctxToast, t("error.not_found_coordinates"))
      }


    } catch (error) {
      console.error(error);
    } finally {
      hideSpinner();
    }

  }

  const handleSubmit = async () => {
    const formData = new FormData();
    showSpinner();
    if (selectedLogo){
      formData.append('logo', selectedLogo);
    }else{
      const response = await fetch('/logo-white-bg.png');
      const blob = await response.blob();
      const defaultLogo = new File([blob], 'logo512.png', { type: 'image/png' });
      formData.append('logo', defaultLogo);
    }

    if (selectedCoverImageDesktop) formData.append('imgDesktop', selectedCoverImageDesktop);
    if (selectedCoverImageMobile) formData.append('imgMobile', selectedCoverImageMobile);

    try {
      await AccomodationService.checkAccomodationLatLon({
        lon: longitude,
        lat: latitude,
        zoom: 18,
        format: "jsonv2"
      });
    } catch (error) {
      console.log(error);
      errorToast(ctxToast,t("error.wrong_address"));
      return
    } finally {
      hideSpinner();
    }

    try {
      showSpinner();
      const token = Cookies.get(COOKIE_ENUM.HST_USER_TOKEN);
      if (token) {
        for (let i = 0; i < rows.length; i++) {
          const [key, value] = rows[i];

          if (((key && !value) || (!key && value)) || (key.trim() === "" || value.trim() === ""))  {
              errorToast(ctxToast, t("error.complete_both_fields"));
              hideSpinner();
              return; 
          }
        }

        const obj = Object.fromEntries(rows);

        const contactDto = new Contact(
          contacts.whatsapp,
          contacts.phone,
          contacts.mobile,
          contacts.email,
          contacts.website,
          contacts.airbnb,
          contacts.booking,
          contacts.facebook,
          contacts.instagram,
          contacts.youtube,
          contacts.tiktok,
          obj
        )
        const locationDto = new Location(
          fullAddress,
          city,
          country,
          latitude,
          longitude
        );

        const baseAccomodation = new BaseAccomodation(title, contactDto, locationDto);
        const saveAccomodation = new SaveAccomodation(details, baseAccomodation)
        const bodyStr = JSON.stringify(saveAccomodation);
        formData.append('body', new Blob([bodyStr], { type: 'application/json' }));
        const response = await AccomodationService.createAccomodation(formData);        
        navigate('/new-app/' + response.accomodation.id);
      } else {
        navigate('/login');
      }
    } catch (error) {
      console.error("Errore nella creazione di una nuova accomodation:", error);
    } finally {
      hideSpinner();
    }
  };

  const handleRemoveTopBox = (idx: number, e: React.MouseEvent) => {
    e.stopPropagation();
    switch (idx) {
      case 0:
        setSelectedLogo(null);
        setLogoPreview(null);
        break;
      case 1:
        setSelectedCoverImageDesktop(null);
        setCoverDesktopPreview(null);
        break;
      case 2:
        setSelectedCoverImageMobile(null);
        setCoverMobilePreview(null);
        break;
    }
    // reset input file
    const inputEl = document.getElementById(`fileInput-${idx}`) as HTMLInputElement;
    if (inputEl) inputEl.value = "";
  };

  const handleContactChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setContacts((prevContacts) => ({
      ...prevContacts,
      [event.target.name]: event.target.value,
    }));
  }

  const handleRemoveRow = (index: number) => {
    setRows(prevRows => prevRows.filter((_, i) => i !== index));
  };


  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div className="card shadow-lg" style={{ width: '70%', borderRadius: '25px' }}>
        <div className="hst-card-header card-header text-uppercase">
          {t('label.create_hostyble')}
        </div>
        <div className="card-body">
          
          <CForm className="p-5">
            <p className="mb-5">{t("page_description.create_hostyble")}</p>
            <CFormInput
              type="text"
              label={`${t('label.title')} ${t('placeholder.obligatory')}`}
              className="mb-3"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
            <CFormTextarea
              label={`${t("label.details")} ${t('placeholder.obligatory')}`}
              rows={5}
              className="mb-4"
              value={details}
              onChange={(e) => setDetails(e.target.value)}
              placeholder={`${t('placeholder.details_placeholder')}`}
            />
            <div className="row">
              <h3 className="mb-3" style={{ color: 'var(--primary-color)' }}>{t("label.address")}</h3>
              <div className="col-12">
                <CFormInput
                  type="text"
                  label={`${t('label.full_address')} ${t('placeholder.obligatory')}`}
                  className="mb-3"
                  value={fullAddress}
                  onChange={(e) => setFullAddress(e.target.value)}
                  disabled={!!latitude && !!longitude}
                  required
                />
              </div>
              <div className="col-12 col-md-6">
                <CFormInput
                  type="text"
                  className="mb-3"
                  label={`${t('label.city')} ${t('placeholder.obligatory')}`}
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                  disabled={!!latitude && !!longitude}
                  required
                />
              </div>
              <div className="col-12 col-md-6">
                <CFormInput
                  type="text"
                  className="mb-3"
                  label={`${t('label.country')} ${t('placeholder.obligatory')}`}
                  value={country}
                  onChange={(e) => setCountry(e.target.value)}
                  disabled={!!latitude && !!longitude}
                  required
                />
              </div>
              <div className="mt-3 col-md-12 d-flex flex-column flex-md-row gap-md-5 justify-content-lg-center">
                <Button
                  className="hst-btn-primary mb-md-0 mb-3"
                  onClick={handleFullAddressSubmit}
                  disabled={!(!!fullAddress && !!city && !!country) || (!!latitude && !!longitude)}
                >
                  {t('button.validate')}
                </Button>
                <Button
                  className="hst-btn-clean"
                  onClick={() => {
                    setFullAddress('')
                    setCity('')
                    setCountry('')
                    setLatitude(0)
                    setLongitude(0)
                  }}
                  disabled={!latitude && !longitude}
                >
                  {t('button.clean')}
                </Button>
              </div>
            </div>
            <h3 style={{ marginTop: "50px", color: "#3B82F6" }} className="mb-3">{t("label.create_album")}</h3>
            <p>{t("label.img_type")}</p>
            <p>{t("label.images_suggestion")}</p>
            <div
              className="mb-3 img-container"
            >
              {[
                { file: selectedLogo, preview: logoPreview, label: t('label.logo_upload'), onChange: (e: React.ChangeEvent<HTMLInputElement>) => handleFileChange(e, ACCOMODATION_IMAGE_TYPE.IMAGE_LOGO) },
                { file: selectedCoverImageDesktop, preview: coverDesktopPreview, label: t('label.cover_upload_web'), onChange: (e: React.ChangeEvent<HTMLInputElement>) => handleFileChange(e, ACCOMODATION_IMAGE_TYPE.IMAGE_COVER_DESKTOP) },
                { file: selectedCoverImageMobile, preview: coverMobilePreview, label: t('label.cover_upload_mobile'), onChange: (e: React.ChangeEvent<HTMLInputElement>) => handleFileChange(e, ACCOMODATION_IMAGE_TYPE.IMAGE_COVER_MOBILE) },
              ].map((item, idx) => (
                <div key={idx} className="w-100">
                  <div
                    style={{
                      border: "2px dashed #ccc",
                      borderRadius: "10px",
                      height: "150px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      background: "#fafafa",
                      position: "relative"
                    }}
                    onClick={() => document.getElementById(`fileInput-${idx}`)?.click()}
                  >
                    {item.preview ? (<>
                      <img
                        src={item.preview}
                        alt={`preview-${idx}`}
                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                      />
                      {/* Bottone close */}
                      <button
                        className="hst-close-button-box"
                        type="button"
                        onClick={(e) => handleRemoveTopBox(idx, e)}
                      >
                        ✕
                      </button>
                    </>
                    ) : (
                      <span style={{ fontSize: "2rem", color: "#aaa" }}>+</span>
                    )}
                    <input
                      type="file"
                      accept=".jpg, .jpeg, .png"
                      id={`fileInput-${idx}`}
                      style={{ display: "none" }}
                      onChange={item.onChange}
                      required
                    />

                  </div>
                  <div style={{ textAlign: "center", width: "100%" }}>
                    {item.label} { item.label == t('label.logo_upload') ? '':t('placeholder.obligatory')}
                  </div>
                </div>
              ))}
            </div>
            {/* contatti */}

            <div className="row mt-5">
              <h3 className="mb-3" style={{ color: 'var(--card-link-color)' }}>{t("label.contacts")}</h3>
              
              <div className="col-12 col-md-6">

                <CFormInput
                  name="whatsapp"
                  type="text"
                  className="contacts-inputs"
                  label={`${t('label.whatsapp')} ${t('placeholder.obligatory')}`}
                  value={contacts.whatsapp}
                  onChange={(e) => handleContactChange(e)}
                  required
                  maxLength={13}
                  placeholder="es. +393254445556"
                />
                <CFormInput
                  name="mobile"
                  type="text"
                  className="contacts-inputs"
                  label={`${t('label.mobile')} ${t('placeholder.obligatory')}`}
                  value={contacts.mobile}
                  maxLength={13}
                  onChange={(e) => handleContactChange(e)}
                  required
                  placeholder="es. +393254445556"
                />
                <CFormInput
                  name="booking"
                  type="text"
                  className="contacts-inputs"
                  label={`${t('label.booking')}`}
                  value={contacts.booking}
                  onChange={(e) => handleContactChange(e)}
                  placeholder={`${t('placeholder.booking')}`}
                />
              </div>

              <div className="col-12 col-md-6">

                <CFormInput
                  name="email"
                  type="text"
                  className="contacts-inputs"
                  label={`${t('label.email')} ${t('placeholder.obligatory')}`}
                  value={contacts.email}
                  onChange={(e) => handleContactChange(e)}
                  required
                  placeholder={`${t('placeholder.email')}`}
                />
                <CFormInput
                  name="phone"
                  type="text"
                  className="contacts-inputs"
                  label={`${t('label.telephone')}`}
                  value={contacts.phone}
                  onChange={(e) => handleContactChange(e)}
                  placeholder="es. 040 123 4567"
                />
                <CFormInput
                  name="airbnb"
                  type="text"
                  className="contacts-inputs"
                  label={`${t('label.airbnb')}`}
                  value={contacts.airbnb}
                  onChange={(e) => handleContactChange(e)}
                  placeholder={`${t('placeholder.airbnb')}`}
                />

              </div>
              <p>{t("label.contacts_info")}</p> 
              <div className="row g-3 w-100 m-0">
                <div className="col-12 col-md-6 col-xl-3">
                  <CFormInput
                    name="facebook"
                    type="text"
                    className="contacts-inputs"
                    label={t('label.facebook')}
                    value={contacts.facebook}
                    onChange={handleContactChange}
                    placeholder={`${t('placeholder.facebook')}`}
                  />
                </div>

                <div className="col-12 col-md-6 col-xl-3">
                  <CFormInput
                    name="instagram"
                    type="text"
                    className="contacts-inputs"
                    label={t('label.instagram')}
                    value={contacts.instagram}
                    onChange={handleContactChange}
                    placeholder={`${t('placeholder.instagram')}`}
                  />
                </div>

                <div className="col-12 col-md-6 col-xl-3">
                  <CFormInput
                    name="youtube"
                    type="text"
                    className="contacts-inputs"
                    label={t('label.youtube')}
                    value={contacts.youtube}
                    onChange={handleContactChange}
                    placeholder={`${t('placeholder.youtube')}`}
                  />
                </div>

                <div className="col-12 col-md-6 col-xl-3">
                  <CFormInput
                    name="tiktok"
                    type="text"
                    className="contacts-inputs"
                    label={t('label.tiktok')}
                    value={contacts.tiktok}
                    onChange={handleContactChange}
                    placeholder={`${t('placeholder.tiktok')}`}
                  />
                </div>
              </div>


              <div className="col-12">
                <CFormInput
                  name="website"
                  type="text"
                  className="contacts-inputs"
                  label={`${t('label.website')}`}
                  value={contacts.website}
                  onChange={(e) => handleContactChange(e)}
                  placeholder={`${t('placeholder.site')}`}
                />
              </div>
              <div className="col-md-12 d-flex flex-column gap-md-5 align-items-lg-center mt-4">

                <Button
                  className="btn-add-website"
                  onClick={handleAddRow}
                  disabled={rows.length >= 10} // disabilita se ci sono già 10 siti
                >
                  {t('button.add_site')}
                </Button>

                <div className="d-flex flex-column w-100" style={{ justifyContent: 'center', alignItems: 'center' }}>
                  {rows.map(([key, value], index) => {
                    return (
                      <div className="d-flex flex-column align-items-center my-3 w-100" key={index}>
                        <p className="text-start w-100">Sito {index + 1}</p>
                        <div className="d-flex align-items-center w-100 gap-2">
                          <div className="d-flex gap-2 flex-grow-1">
                            <CFormInput
                              name={`otherWebsites_key_${index}`}
                              type="text"
                              className=" w-50"
                              value={key}
                              onChange={(e) => handleDynamicInputChange(e, index, "key")}
                            />
                            <CFormInput
                              name={`otherWebsites_value_${index}`}
                              type="text"
                              className="w-50"
                              value={value}
                              onChange={(e) => handleDynamicInputChange(e, index, "value")}
                            />
                          </div>
                          <div className="d-flex justify-content-center align-items-center">
                            <button
                              type="button"
                              onClick={() => handleRemoveRow(index)}
                              style={{
                                background: 'red',
                                color: 'white',
                                border: 'none',
                                borderRadius: '50%',
                                width: '25px',
                                height: '25px',
                                cursor: 'pointer'
                              }}
                            >
                              ✕
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })} 
                </div>
              </div>
            </div>
          </CForm>
        </div>
        <div
          className="card-footer"
          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding:'16px 32px' }}
        >
          <Button
            className="btn-hostyble btn-add-accommodation"
            onClick={handleSubmit}
            disabled={isDisabled}
            style={{fontWeight:"500"}}
          >
            {t('button.save')}
          </Button>
        </div>
      </div>
    </div>
  );
}
